import React from 'react';
import Text, { TextProps } from './Text';

const SmallCaps = (props: TextProps) => <Text textTransform="uppercase" fontWeight="bold" {...props} />;

export default SmallCaps;
